<template>
  <section class="login">
    <h3 class="login-title">用户登录</h3>
    <a-form style="height:410px;">
      <a-form-item class="tel-item">
        <a-input placeholder="请输入手机号" type="tel" v-model.trim="tel"  @focus="isTelFocus = true" @blur="isTelFocus = false">
          <div slot="prefix">
            <img src="../../../assets/image/login-tel-active.png" alt="" class="icon" v-if="isTelFocus">
            <img src="../../../assets/image/login-tel.png" alt="" class="icon" v-else>
          </div>
        </a-input>
      </a-form-item>
      <a-form-item class="code-item">
        <a-input placeholder="请输入验证码" v-model.trim="code" class="code-input" @focus="isCodeFocus = true" @blur="isCodeFocus = false">
          <div slot="prefix">
            <img src="../../../assets/image/login-code-active.png" alt="" class="icon" v-if="isCodeFocus">
            <img src="../../../assets/image/login-code.png" alt="" class="icon" v-else>
          </div>
        </a-input>
        <a-button type="primary" class="code-btn" :class="{disabled:!send_code_status}" @click="get_code"  :disabled="!send_code_status" v-if="send_code_status">获取验证码</a-button>
        <a-button type="primary" class="code-btn" style="background:#b0aca9;font-size:18px;" :disabled="true" v-else>{{send_code_time}}</a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" class="sure-btn" @click="login">确定</a-button>
      </a-form-item>
      <div style="margin: 0;text-align:center;">
        <a style="color: red;font-weight: bold;">严禁在本互联网非密平台，处理、传输国家秘密。</a>
      </div>
    </a-form>
  </section>
</template>
<script>
import { Common } from '../../../common/Common'
import { Login } from '../../../common/login/Login'
export default {
  mixins: [Common, Login],
}
</script>
<style lang="less" scoped>
.login{
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  &-title{
    margin: 40px 0 33px;
    height: 26px;
    line-height: 26px;
    font-size:26px;
    font-weight:400;
    color:rgba(0,77,154,1);
    text-align: center;
  }
  & /deep/ .ant-form{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto 100px;
    padding-left: 27px;
    width:683px;
    height:377px;
    border:1px solid rgba(204,204,204,1);
    border-radius:9px;
    box-sizing: border-box;
    .tel-item{
      margin-top: 60px;
      height: 55px;
      width: 435px;
      .ant-form-item-control{
        height: 55px;
      }
      .ant-form-item-children{
        display: flex;
        align-items: center;
        .ant-input{
          padding-left: 40px;
          height: 55px;
          width: 435px;
          font-size:15px;
          font-weight:400;
          color:rgba(0,0,0,1);
          &::placeholder{
            font-size:15px;
            font-weight:400;
            color:rgba(102,102,102,1);
          }
        }
      }
      & /deep/ .ant-input-prefix > div{
        line-height: 1;
      }
      .icon{
        width: 20px;
        height: 20px;
      }
    }
    .code-item{
      margin-top: 30px;
      height: 55px;
      width: 435px;
      .ant-form-item-control{
        height: 55px;
      }
      .ant-form-item-children{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .ant-input{
          padding-left: 40px;
          height: 55px;
          width: 229px;
          font-size:15px;
          font-weight:400;
          color:rgba(0,0,0,1);
          &::placeholder{
            font-size:15px;
            font-weight:400;
            color:rgba(102,102,102,1);
          }
        }
        .code-btn{
          flex-shrink: 0;
          width:168px;
          height:55px;
          font-size:15px;
          font-weight:400;
          color:rgba(255,255,255,1);
          background:rgba(193,102,19,1);
          border-radius:4px;
        }
      }
      & /deep/ .ant-input-prefix > div{
        line-height: 1;
      }
      .icon{
        width: 20px;
        height: 20px;
      }
    }
    .sure-btn{
      margin-top: 30px;
      width:441px;
      height:60px;
      font-size:20px;
      font-weight:400;
      color:rgba(255,255,255,1);
      background:rgba(193,102,19,1);
      border-radius:9px;
    }
  }
}
</style>
